import { createContext } from "react";
import { initialAddOns } from "../init";

const AddOnsContext = createContext(initialAddOns);

export default AddOnsContext;
